import dayjs        from 'dayjs';
import { Dayjs }    from 'dayjs';
import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

type WithUndefined<T> = {
  [P in keyof T]?: T[P] | undefined;
};

export default class StandModel extends ApiModel {
  static get path() {
    return '/backend/stands/{?id}';
  }

  filters: WithUndefined<{
    'aisle': string;
    'documentsTreated': boolean;
    'exists[mountingAttestations]': boolean;
    'hall': string;
    'id': string;
    'mountingAttestations.anchoring': boolean;
    'mountingAttestations.ballasting': boolean;
    'mountingAttestations.electricalPowerKva[gte]': number;
    'mountingAttestations.electricalPowerKva[lte]': number;
    'mountingAttestations.groundHeightCategory': string;
    'mountingAttestations.guying': boolean;
    'mountingAttestations.selfSupporting': boolean;
    'mountingAttestations.suspendedEquipmentSecured': boolean;
    'name': string;
    'nbClosedReports[gte]': number;
    'nbClosedReports[lte]': number;
    'nbInProgressReports[gte]': number;
    'nbInProgressReports[lte]': number;
    'number': string;
    'show': string;
    'standDocumentStatus.reference': string;
    'standLayouts.layoutType': string;
    'standLayouts.layoutType.reference': string;
    'standSecurityInstruction.builtByOne': boolean;
    'standType': string;
    'status': string;
    'surface[gte]': number;
    'surface[lte]': number;
    'treated': boolean;
    'unSeen': boolean;
    'unSeenDocuments': boolean;
  }> = {};

  @computed
  get name(): string {
    return this.get('name', '');
  }

  @computed
  get hall(): number {
    return this.get('hall', 0);
  }

  @computed
  get aisle(): number {
    return this.get('aisle', 0);
  }

  @computed
  get number(): number {
    return this.get('number', 0);
  }

  @computed
  get surface(): string {
    return this.get('surface', '0');
  }

  @computed
  get bat(): boolean {
    return this.get('bat', false);
  }

  @computed
  get standType(): string {
    return this.get('standType', '');
  }

  @computed
  get showId(): id {
    return this.get('show.id', '');
  }

  @computed
  get status(): number {
    return this.get('status', '');
  }

  @computed
  get standDocumentStatusId(): id {
    return this.get('standDocumentStatus.id', '');
  }

  @computed
  get standDocumentStatusReference(): string {
    return this.get('standDocumentStatus.reference', '');
  }

  @computed
  get standSecurityInstruction(): boolean {
    return this.get('standSecurityInstruction');
  }

  @computed
  get unSeen(): boolean {
    return this.get('unSeen');
  }

  @computed
  get treated(): boolean {
    return this.get('treated');
  }

  @computed
  get documentsTreated(): boolean {
    return this.get('documentsTreated');
  }

  @computed
  get unSeenDocuments(): boolean {
    return this.get('unSeenDocuments');
  }

  @computed
  get nbInProgressReports(): number {
    return this.get('nbInProgressReports');
  }

  @computed
  get nbClosedReports(): number {
    return this.get('nbClosedReports');
  }

  @computed
  get updatedAt(): string {
    return this.get('updatedAt');
  }

  @computed
  get updatedAtDate(): Dayjs {
    return dayjs(this.updatedAt);
  }

  @computed
  get documentsUpdatedAt(): string {
    return this.get('documentsUpdatedAt');
  }

  @computed
  get documentsUpdatedAtDate(): Dayjs {
    return dayjs(this.documentsUpdatedAt);
  }
}
